<template lang="pug">
	section#oportunidade
		.wrapper
			.text
				.title
					h1 APROVEITE ESSA #[span OPORTUNIDADE!]
					img(src="@images/prouniHome/oportunidade.png")
				p É importante ficar de olho para não perder o prazo e nem a chance de estudar de graça na UNIFAEL.
				p O envio da documentação é totalmente online, mas caso precise de apoio, compareça ou entre em contato com a unidade UNIFAEL que escolheu no momento da sua inscrição!
			.image
				h1 ESSA É #[span A SUA CHANCE] #[span.iniciar DE INICIAR] #[span.sua A SUA] #[span.graduacao GRADUAÇÃO!]
</template>

<script>
export default {
	name: "section-oportunidade"
}
</script>

<style lang="stylus" scoped src="./Oportunidade.styl"></style>
